var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessToastMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3CD860",
    d: "M24,47.5C11.102,47.5,0.5,36.898,0.5,24S11.102,0.5,24,0.5S47.5,11,47.5,24 C47.5,36.898,36.898,47.5,24,47.5z M24,3.199C12.602,3.199,3.199,12.602,3.199,24S12.5,44.801,24,44.801 c11.398,0,20.801-9.301,20.801-20.801C44.801,12.602,35.398,3.199,24,3.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CD860",
    d: "M19.102,32.898c-0.301,0-0.703-0.098-1-0.398l-5.801-5.801c-0.5-0.5-0.5-1.398,0-1.898s1.398-0.5,1.898,0 l4.902,4.898l14.297-14.301c0.5-0.5,1.402-0.5,1.902,0s0.5,1.402,0,1.902L20,32.602C19.801,32.699,19.398,32.898,19.102,32.898z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastMessage);
export default __webpack_public_path__ + "static/media/Success Toast Message.609c34d52f2aa05a1d5c7351c6c44b63.svg";
export { ForwardRef as ReactComponent };